// START Open Requre.JS wrapper
define([
	'jquery',
	'pubsub',
	'datalayer.cms.signupform'
	], function($, pubsub) {
// END Open Require.JS wrapper


	/****
	 * Signup Form handles email signup fields used in various places on the page
	 *
	 *
	 ***/
	var PLUGIN_IDENTIFIER = "signupForm";
	var signupForm = function( element, options ) {
		this.element = element;
		this.messageDisplay = $(this.element).find('.signup-message.hide');
		this.options = options;

		// This next line takes advantage of HTML5 data attributes
		// to support customization of the plugin on a per-element
		// basis. For example,
		// <form class='signup' data-signupform-options='{"message":"Goodbye World!"}'></section>
		this.metadata = $(this.element).data('signupform-options');
	};

	signupForm.prototype = {
		defaults: {
			successMessage : "Thank you for signing up.",
			errorMessage : "There was a problem. Please try again later.",
			alreadySubscribedMessage: "Sorry, this address already exists."
		},

		init : function () {
			console.log('initilizing form for',$(this.element));

			this.config = $.extend( {}, this.defaults, this.options, this.metadata );

			this._build();

			var self = this;

			// Setup form processing behavior. Run form only when it validates using Foundation Abide
			// Foundation 5 has data-abide="ajax" which is a cleaner solution
			$(self.element).on("submit", function(e) {
				e.preventDefault(); // Stop normal form submission
            });

            // Don't submit if unless Abide says valid
            $(self.element).on('formvalid.zf.abide', function () {
	                
                // AJAX form submit and handling
                $.ajax({
                    url: $(this).attr('action'),
                    type: $(this).attr('method'),
                    data: $(this).serialize(),
                    processData: true,
                    cache: false,
                    success: function(response) {
                        console.log('form response',response);
                        if(response.errorMessage !== undefined ) {
                        	self.showResult(self.getErrorMessage(response), 'alert');
                            self.publishSignupResult(false);
                        } else {
                            self.showResult(self.config.successMessage,'success');
                            self.publishSignupResult(true, response);
                        }
                    },
                    error: function(error) {
                        console.log('form error',error);
                        self.showResult(self.config.errorMessage,'alert');
                        self.publishSignupResult(false);
                    }
                });
            });
			
			return self;
		},

		/**
		 * Modify the DOM to support layout
		 **/
		_build : function() {

		},

		getErrorMessage : function (response) {
			var self = this;

			if(response.errorMessage === 'UserAlreadySubscribed') {
				return self.config.alreadySubscribedMessage;
			} else {
				return response.errorMessage;
			}
		},

		/**
		 * Display a result message
		 * @param string Message to display. Use null for default message in the HTML.
		 * @param string Type of message error|success|alert
		 */
		showResult : function( message, alerttype) {
			var self = this;
			$(self.messageDisplay).addClass("hide");
			$(self.messageDisplay).find('.callout').remove(); // Prevent more than one message at a time

			$(self.messageDisplay).append("<div data-closable class='callout "+alerttype+"'><span>"+message+"</span><a data-close class='close'>&times;</a>");
			
			$(self.messageDisplay).removeClass("hide");
		}, 

		publishSignupResult : function (result, response) {
			var pubSubObj = {
				"result": result,
				"response": response
			};

			$.pubsub('publish', 'vfdp.aem.footer.emailsignup', pubSubObj);
		}

	};

	signupForm.defaults = signupForm.prototype.defaults;

	// prevent duplicate instantiation
	$.fn.signupForm = function(options) {
		return this.each(function() {
			var instance = $(this).data(PLUGIN_IDENTIFIER);
			if(!instance) {
				instance = new signupForm(this, options).init();
				$(this).data(PLUGIN_IDENTIFIER,instance);
			}
		});
	};



// START close Require.JS wrapper		
	}
);
// END close Require.JS wrapper
